import type { BBox } from '@onefootprint/request-types/dashboard';
import type { Rotation } from '@/utils/rotation';

const rotateBbox = (bbox: BBox, rotation: Rotation, documentWidth: number, documentHeight: number): BBox => {
  if (rotation === 90) {
    return { x: documentHeight - bbox.y - bbox.height, y: bbox.x, width: bbox.height, height: bbox.width };
  }
  if (rotation === 180) {
    return {
      x: documentWidth - bbox.x - bbox.width,
      y: documentHeight - bbox.y - bbox.height,
      width: bbox.width,
      height: bbox.height,
    };
  }
  if (rotation === 270) {
    return { x: bbox.y, y: documentWidth - bbox.x - bbox.width, width: bbox.height, height: bbox.width };
  }
  return bbox;
};

export default rotateBbox;
